/* Wav Monopoly — interactive plugin "explore" hotspots <-> control list */
(function () {
  if (window.__wmExploreInit) return;
  window.__wmExploreInit = true;

  function setActive(root, i) {
    root.querySelectorAll('[data-i]').forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-i') === i);
    });
  }
  function clearActive(root) {
    root.querySelectorAll('.is-active').forEach(function (el) { el.classList.remove('is-active'); });
  }

  function init(root) {
    if (root.__wmInit) return;
    root.__wmInit = true;
    var onEnter = function (e) {
      var t = e.target.closest('[data-i]');
      if (t && root.contains(t)) setActive(root, t.getAttribute('data-i'));
    };
    root.addEventListener('mouseover', onEnter);
    root.addEventListener('focusin', onEnter);
    root.addEventListener('click', onEnter);
    root.addEventListener('mouseleave', function () { clearActive(root); });
  }

  function initAll() { document.querySelectorAll('[data-wm-explore]').forEach(init); }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
